import { Outlet } from "react-router-dom";

import { FilterRewardProvider } from "./filter-reward/filter-reward.context";
import './reward.scss';

export function Reward() {
  return (
    <div id="ShellReward" className="reward">
       <FilterRewardProvider>
        <Outlet />
      </FilterRewardProvider>
    </div>
  );
}

export default Reward;
